import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
//import { MasterData } from '../../../api/contract-notice-dto';
import { MasterDataDTO, getParentIdentifierFromString, getSimpleIdentifierFromString, TaskDTO } from '../../../api/plyca-dtos';
import { ContractDTO, WarrantyDTO } from '../../../api/plyca-dtos-v2';
import { FormConfig } from '../../../components/forms/form.objects';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../baseFormComponent/baseForm.component';
import { GuaranteePaymentsDTO, GuaranteeRefundDTO } from '../model/guaranteeRefund.model';
import * as lodash from 'lodash';
import { ProjectOrganizationalSnapshotValidations } from '../../projectOrganizationalSnapshot/component/projectOrganizationalSnapshot.validation';

export class GuaranteeRefundModel {
  dto: GuaranteeRefundDTO;
  ui: {
    divisionId?: string,
    dossierId?: string,
    edition?: boolean;
    isModeError?: boolean;
    isREPLYCATask?: boolean;
    isProjectReplyca?: boolean,
    agreementDate?: Date,
    allModality?: any[],
    contractModificationType?: string;
    activeTemporayPeriodOrganizationalChange?: boolean;
    enabledPreviousOrganizationalUnitRegistration?: boolean;
    selectedProjectOrganizationalSnapshot?: any;
  };
}

@Component({
  selector: 'guaranteeRefund',
  //templateUrl: '../../baseFormComponent/baseForm.template.html'
  templateUrl: '../../../dossiers/registerContractModifications/registerContractModification.template.html',
  providers: [ProjectOrganizationalSnapshotValidations]
})
export class GuaranteeRefundComponent extends BaseFormComponent<GuaranteeRefundDTO, GuaranteeRefundModel> implements OnInit, OnDestroy {
  private contract: ContractDTO;
  constructor(
    private projectOrganizationalSnapshotValidations: ProjectOrganizationalSnapshotValidations,
    elem: ElementRef) {
    super(elem);
  }

  ngOnInit(): void {
    if (this.task && this.task.work && this.task.work['guaranteeRefund'] && this.task.work['guaranteeRefund'].contract) {
      console.log('INVOCACION DE GuaranteeRefund DESDE TAREA', this.task);
      this.contract = this.task.work['guaranteeRefund'].contract;
    }
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  getFormSettingURL(): string {
    return 'guaranteeRefund/guaranteeRefundSettings.json';
  }
  getServiceURL(): string {
    return undefined;
  }
  getObjectIdentifier() {
    return undefined;
  }


  dtoToModel(dto: GuaranteeRefundDTO): Observable<GuaranteeRefundModel> {
    let model = new GuaranteeRefundModel();

    model.dto = this.task.work['guaranteeRefund'];

    model.ui = {
      edition: true,
      isModeError: false,
      isREPLYCATask: false,
      isProjectReplyca: false,
      contractModificationType: null,
      activeTemporayPeriodOrganizationalChange: false,
      enabledPreviousOrganizationalUnitRegistration: false,
      selectedProjectOrganizationalSnapshot: new Object()
    };

    model.ui.contractModificationType = this.translate.instant('GuaranteeRefund.detail.contractModificationType.value');
    if (this.task && this.task.work) {

      if (this.task.work.context && this.task.work.context.configurations) {
        if (this.task.work.context.configurations['agreementDate']) {
          model.ui.agreementDate = this.task.work.context.configurations['agreementDate'].value;
        }
        if (this.task.work.context.configurations['screenMode']) {
          if (this.task.work.context.configurations['screenMode'].value == 'RECTIFICA' || this.task.work.context.configurations['screenMode'].value == 'ANULA') {
            model.ui.isModeError = true;
            if (this.task.work.context.configurations['screenMode'].value == 'ANULA') {
              model.ui.edition = false;
            }
          }
          if (model.dto.listWarrantyPayments) {
            model.dto.listWarrantyPayments
              .forEach(element => {
                element.editable = false;
              });
          }
        }

        if (this.task.work.context.configurations['isREPLYCATask'].value == '1') {
          model.ui.isREPLYCATask = true;
        }

        if (this.task.work.context.configurations['isProjectReplyca'].value == '1') {
          model.ui.isProjectReplyca = true;
        }

        model.ui.divisionId = getSimpleIdentifierFromString(model.dto.division.identifier);
        model.ui.dossierId = this.normalizaDossierId(getParentIdentifierFromString(model.dto.division.identifier));
        let warrantyPayments = model.dto.listWarrantyPayments;
        if (warrantyPayments) {
          for (let i in warrantyPayments) {
            let guaranteePayments = warrantyPayments[i];
            if (guaranteePayments.warranty && guaranteePayments.warranty.identifier && guaranteePayments.warranty.identifier == '0') {
              guaranteePayments.warranty.identifier = null;
            }
          }
        }


        if (model.dto?.context && model.dto.context.configurations['activeTemporayPeriodOrganizationalChange']) {
          model.ui.activeTemporayPeriodOrganizationalChange = model.dto.context.configurations['activeTemporayPeriodOrganizationalChange'].value;
          if (model.ui.activeTemporayPeriodOrganizationalChange) {
            model.ui.enabledPreviousOrganizationalUnitRegistration = true;
          } else {
            if (model.dto.previousOrganizationalUnitRegistration !== undefined) {
              //No está activo, pero el campo se ha visualizado en algun monmento: subsanacion
              model.ui.enabledPreviousOrganizationalUnitRegistration = false;
            }
          }
        }

        model.ui.selectedProjectOrganizationalSnapshot = model.dto.projectOrganizationalSnapshot;
      }
    }


    return of(model);
  }


  private getListModality(listMasterData: any): any[] {
    let elements = [];

    if (listMasterData) {
      listMasterData.forEach(
        (item: MasterDataDTO) => {
          elements.push(this.reduceMasterDataDTO(item));
        });
    }

    return elements;
  }

  private excludeProvisional(requestedMasterData: any): any[] {
    let modality = [];
    requestedMasterData.forEach(
      (data: MasterDataDTO) => {
        //console.log('*********** requestedMasterData: Id:' + getSimpleIdentifierFromString(data.identifier));
        //console.log('*********** requestedMasterData: Descripcion: ' + data.description);
        if (getSimpleIdentifierFromString(data.identifier) != '2') {
          modality.push(data);
        }
      });
    return modality;
  }


  private reduceMasterDataDTO(mastesData: MasterDataDTO) {
    // Se limpia el resto de datos para evitar referencias circulares
    let _reduceMaster = {
      'label': mastesData.description,
      'value': mastesData.identifier
    };
    return _reduceMaster;
  }

  modelToDTO(model: GuaranteeRefundModel): GuaranteeRefundDTO {
    return model.dto;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Devolución de garantías';
    headerInfo.titleIcon = 'fas fa-hand-holding';
    headerInfo.project = this.model.dto.division.project;
    return headerInfo;
  }


  /*protected updateTask(updatedTask: TaskDTO) {
    this.formService.merge(this.task, updatedTask);
  }*/

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.accept',
        'fas fa-lg fa-check',
        'btn-primary',
        true,
        this.windowHash
      ),
      success => {
        this.processTask();
      });
    this.headerActionsService.addDivider();
    this.addBackAction();
  }


  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    this.loadFunctions(formConfig);
    return super.configureFormConfig(formConfig);
  }

  loadFunctions(_formConfig: FormConfig) {
    console.log('loadFunctions');
    _formConfig.functions.push({
      identifier: 'changeAssociatedWarranty',
      fn: this.changeAssociatedWarranty.bind(this)
    });
    _formConfig.functions.push({
      identifier: 'newGuaranteePayments',
      fn: this.newGuaranteePayments.bind(this)
    });
    _formConfig.functions.push({
      identifier: 'setModalidad',
      fn: this.setModalidad.bind(this)
    });
    _formConfig.functions.push({
      identifier: 'loadOrganizationalSnapshotData',
      fn: this.projectOrganizationalSnapshotValidations.loadOrganizationalSnapshotData
    });
    _formConfig.functions.push({
      identifier: 'changeProjectOrganizationalSnapshot',
      fn: this.projectOrganizationalSnapshotValidations.changeProjectOrganizationalSnapshot
    });
    _formConfig.functions.push({
      identifier: 'visiblePreviousOrganizationalUnitRegistration',
      fn: this.projectOrganizationalSnapshotValidations.visiblePreviousOrganizationalUnitRegistration
    });

  }

  protected getTask(): TaskDTO {
    this.modelToDTO(this.model);
    this.task.work;
    return this.task;
  }

  /*protected getTask(): TaskDTO {
    this.modelToDTO(this.model);
    this.task.work;
    this.task.work = JSON.parse(
      JSON.stringify(this.task.work, (k, v) => (k === '_parent' ? undefined : v))
    );
    return this.task;
  }*/


  resetAssociateddWarranty(changes?: any) {
    let oldValue = new WarrantyDTO();
    oldValue = changes.oldValue;
    let newValue = new WarrantyDTO();
    newValue = changes.newValue;

    let reset = ((oldValue && newValue) && (oldValue.identifier != newValue.identifier)) || (oldValue === undefined || newValue === undefined);
    console.log('======resetAssociatedWarranty', reset);
    return reset;
  }

  changeAssociatedWarranty(model: any, changes?: any) {
    console.log('EJECUTADO changeAssociatedWarranty - Inicio', model, changes);
    if (this.model.ui.isProjectReplyca) {
      console.log('EJECUTADO changeAssociatedWarranty - No hace nada', model, changes);
      return;
    }
    console.log('EJECUTADO changeAssociatedWarranty -  dowork', model, changes);
    let reset = this.resetAssociateddWarranty(changes);

    //let newValue = new GuaranteePaymentsDTO();
    let modality;
    if (reset) {
      let warranty = changes.newValue;
      if (warranty == null || warranty === undefined) {
        modality = null;
      } else {
        modality = warranty.modality;
      }
      model.modality = modality;
    }
  }

  normalizaDossierId(dossierId: string): string {
    return dossierId.substring(0, 4) + '/' + dossierId.substring(4);
  }

  newGuaranteePayments(model: any) {
    //    return new Promise(resolve => {
    //    return defer(() => {
    console.log('invocacion a newGuaranteePayments', model);
    let guaranteePayments;
    if (!model) {
      guaranteePayments = lodash.cloneDeep(model);
    } else {
      guaranteePayments = new GuaranteePaymentsDTO();
    }
    guaranteePayments.agreementDate = this.model.ui.agreementDate;
    return guaranteePayments;
  }
  setModalidad(model: any) {
    if (model.modality == null || model.modality === undefined) {
      if (model.warranty != null && model.warranty.identifier != null) {
        return model.warranty.modality;
      }

    }
    console.log('*****************************model.modality.identifier', model.modality.identifier);
    return model.modality.identifier
    //model.modality = {};
    //model.modality.identifier = '3<>GARANTIA_MODALIDAD';


  }
}